import { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}
interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(): State {
    return { hasError: true };
  }
  componentDidCatch(error: Error, info: { componentStack?: string | null }) {
    console.error('ErrorBoundary:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-cream">
          <div className="text-center max-w-sm px-6">
            <h2 className="font-sans text-2xl text-ink mb-3">Something unexpected happened</h2>
            <p className="text-sm text-ink-faint mb-8">Don&apos;t worry &mdash; your data is safe. Try refreshing, or head back to your dashboard.</p>
            <div className="flex justify-center gap-3">
              <button
                onClick={() => (window.location.href = '/dashboard')}
                className="btn-primary text-xs"
              >
                Dashboard
              </button>
              <button onClick={() => window.location.reload()} className="btn-secondary text-xs">
                Refresh
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
